export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [
      {index: 0, label: 'Trang chủ', url: '/', labelIcon: 'HomeIcon', highlightAction: false},
      {index: 1, label: 'Đối tác', url: '/offer', labelIcon: 'BriefcaseIcon', highlightAction: false},
      {index: 2, label: 'Tin khuyến mãi', url: '/promotion', labelIcon: 'AwardIcon', highlightAction: false},
      {index: 3, label: 'Link đã tạo', url: '/tool/created-links', labelIcon: 'FileIcon', highlightAction: false},
      {index: 4, label: 'Dynamic Link', url: '/tool/dynamic-links', labelIcon: 'FileIcon', highlightAction: false},
      {index: 5, label: 'Smart Script', url: '/tool/smart-script', labelIcon: 'FileIcon', highlightAction: false},
      {index: 6, label: 'Parking Domain', url: '/tool/parking-domain', labelIcon: 'FileIcon', highlightAction: false},
      {index: 7, label: 'Product Generate', url: '/product-generate', labelIcon: 'FileIcon', highlightAction: false},
      {index: 8, label: 'Hyperlead\'s API', url: '/tool/hyperlead-api', labelIcon: 'FileIcon', highlightAction: false},
      {index: 9, label: 'WordPress Plugins', url: '/tool/wordpress-plugins', labelIcon: 'FileIcon', highlightAction: false},
      {index: 10, label: 'Báo cáo đơn hàng', url: '/report/order', labelIcon: 'FileIcon', highlightAction: false},
      {index: 11, label: 'Báo cáo hiệu quả', url: '/report/performance', labelIcon: 'FileIcon', highlightAction: false},
      {index: 12, label: 'Báo cáo doanh thu', url: '/report/revenue', labelIcon: 'FileIcon', highlightAction: false},
      {index: 13, label: 'Lịch sử thanh toán', url: '/report/invoice', labelIcon: 'FileIcon', highlightAction: false},
      {index: 14, label: 'Sản phẩm bán chạy', url: '/report/top-sale', labelIcon: 'FileIcon', highlightAction: false},
      {index: 15, label: 'Quy định & Chính sách', url: '/support/policies', labelIcon: 'FileIcon', highlightAction: false},
      {index: 16, label: 'Về HyperLead', url: '/support/about', labelIcon: 'FileIcon', highlightAction: false},
  ]
}



// WEBPACK FOOTER //
// ./src/layouts/components/navbar/navbarSearchAndPinList.js